import React, { useState } from 'react';
import GenerarDocumentoModal from '../components/GenerarDocumentoModal';

const GenerarDocumentosPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">Generación de Documentos de Gestión</h1>
      
      <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
        <h2 className="text-xl font-semibold mb-2">Planificación Curricular Anual</h2>
        <p className="text-gray-600 mb-6">
          Genera el documento Word (.docx) con tu planificación anual, cruzando las competencias, unidades y sesiones que has organizado.
        </p>

        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-indigo-600 text-white px-6 py-2 rounded-md hover:bg-indigo-700 transition-colors shadow-sm font-medium"
        >
          Configurar y Generar Word
        </button>
      </div>

      <GenerarDocumentoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default GenerarDocumentosPage;